module.exports = __webpack_public_path__ + "img/enableupdate.bc90e53b.svg";